import {
  ADMIN_USERS_LIST,
  ADMIN_USER_ADD,
  ADMIN_USER_CHANGE_STATUS,
  ADMIN_USER_DELETE,
  ADMIN_USER_EDIT,
} from "../constants/api-path";
import httpClient from "./http.interceptor";

export const getStoreAdmins = (formData: any): Promise<any> => {
  return httpClient.get(ADMIN_USERS_LIST, {
    params: {
      page: formData.page,
      pageSize: formData.limit,
      sort: formData.sort,
      search: formData.search,
      country_id: formData.country_id,
      province_id: formData.province_id,
      city_id: formData.city_id,
      store_id: formData.store_id,
    },
  });
};

export const addStoreAdmin = (formData: any): Promise<any> => {
  formData.role_id = 2;
  return httpClient.post(ADMIN_USER_ADD, formData);
};

export const updateStoreAdmin = (id: string, formData: any): Promise<any> => {
  return httpClient.put(ADMIN_USER_EDIT + id, formData);
};

export const deleteStoreAdmin = (id: string | number): Promise<any> => {
  return httpClient.delete(ADMIN_USER_DELETE + id);
};

export const changeStoreAdminStatus = (
  id: string | number,
  formData: any,
): Promise<any> => {
  return httpClient.post(ADMIN_USER_CHANGE_STATUS + id, formData);
};

export const getStoreAdminDetails = (id: string): Promise<any> => {
  return httpClient.get(ADMIN_USER_EDIT + id);
};
